/* eslint-disable react/no-did-mount-set-state */
/* eslint-disable quote-props */
/* eslint-disable react/no-unused-state */
/* eslint-disable camelcase */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-unused-vars */

import React, { PureComponent } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import KeyVariantIcon from 'mdi-react/KeyVariantIcon';
import EyeIcon from 'mdi-react/EyeIcon';
import PropTypes from 'prop-types';
import renderTextInput from '../../../../shared/components/form/TextInput';
import ls from 'local-storage';
import axios from 'axios';
import showNotifications from '../../../Preferences/notificationMessages';
import { Redirect } from 'react-router-dom';
import { translate } from 'react-i18next';

class ChangePassordForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      token: '',
      apiws: '',
      iduser: '',
      min_len_password: 6,
      allow_char: '',
      allow_uppercase: true,
      allow_lowercase: true,
      allow_number: true,
      oldPassword: '',
      showOldPassword: false,
      newPassword: '',
      showNewPassword: false,
      confirmNewPassword: '',
      showConfirmNewPassword: false,
      textError: '',
      spanError: 'none',
      redirect: false,
      regex: '',
    };

    this.showOldPassword = this.showOldPassword.bind(this);
    this.showNewPassword = this.showNewPassword.bind(this);
    this.showConfirmNewPassword = this.showConfirmNewPassword.bind(this);
    this.handleOldPassword = this.handleOldPassword.bind(this);
    this.handleNewPassword = this.handleNewPassword.bind(this);
    this.handleConfirmNewPassword = this.handleConfirmNewPassword.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount = () => {
    this.setState({ token: ls.get('token') });
    this.setState({ apiws: ls.get('ws_ip') });
    this.setState({
      iduser: ls.get('user_cred').usr_id,
    }, () => {
      this.checkPassword();
    });
  }

  checkPassword() {
    const { apiws, token } = this.state;
    console.log(apiws);
    const config = {
      headers: {
        'Authorization': `bearer ${token}`,
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };
    axios.post(
      `${apiws}/apppasswordsetting/getPasswordSetting`,
      '',
      config,
    ).then((response) => {
      if (response.data.status === 'ok') {
        const res = response.data.data;
        const char = res[0].allow_char;
        const min_len = res[0].min_len_password;
        const allow_uppercase = this.checkBoolean(res[0].allow_uppercase);
        const allow_lowercase = this.checkBoolean(res[0].allow_lowercase);
        const allow_number = this.checkBoolean(res[0].allow_number);
        let c = '';
        let u = '';
        let l = '';
        let n = '';
        let m = '';
        if (char !== '' || char !== null) {
          c = char;
        }
        if (allow_uppercase) {
          u = `(?=[a-z0-9${c}]*[A-Z])`;
        }
        if (allow_lowercase) {
          l = `(?=[A-Z0-9${c}]*[a-z])`;
        }
        if (allow_number) {
          n = `(?=[A-Za-z${c}]*[0-9])`;
        }
        if (min_len !== null || min_len !== 0) {
          m = `{${min_len},}`;
        }
        const regEx = `^${u}${l}${n}[A-Za-z0-9${c}]${m}`;
        this.setState({
          regex: regEx,
          min_len_password: res[0].min_len_password,
          allow_char: res[0].allow_char,
          allow_uppercase: this.checkBoolean(res[0].allow_uppercase),
          allow_lowercase: this.checkBoolean(res[0].allow_lowercase),
          allow_number: this.checkBoolean(res[0].allow_number),
        });
      } else {
        console.log('false');
      }
    });
  }

  checkBoolean(x) {
    let val_x;
    if (x === 'true') {
      val_x = true;
    } else {
      val_x = false;
    }
    return val_x;
  }

  showOldPassword() {
    this.setState({
      showOldPassword: !this.state.showOldPassword,
    });
  }

  showNewPassword() {
    this.setState({
      showNewPassword: !this.state.showNewPassword,
    });
  }

  showConfirmNewPassword() {
    this.setState({
      showConfirmNewPassword: !this.state.showConfirmNewPassword,
    });
  }

  handleOldPassword(event) {
    this.setState({
      oldPassword: event.target.value,
      spanError: 'none',
    });
  }

  handleNewPassword(event) {
    this.setState({
      newPassword: event.target.value,
      spanError: 'none',
    });
  }

  handleConfirmNewPassword(event) {
    this.setState({
      confirmNewPassword: event.target.value,
      spanError: 'none',
    });
  }

  handleSubmit(values) {
    const {
      apiws, token, iduser,
    } = this.state;
    console.log(iduser);
    const url = `${apiws}/user/updatePassword/${iduser}`;
    const data = {
      ...values,
      muser_id: iduser,
    };
    const formBody = Object.keys(data).reduce((formData, key) => {
      formData.append(key, data[key]);
      return formData;
    }, new FormData());
    console.log(formBody);
    const config = {
      headers: {
        'Authorization': `bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    };
    axios.post(
      url,
      formBody,
      config,
    ).then((response) => {
      if (response.data.status === 'ok') {
        showNotifications('Success', 'Save Success', 'success');
        this.setState({
          textError: '',
          spanError: '',
        });
        this.setState({ redirect: true });
      } else {
        showNotifications('Fail', 'Save Failed', 'danger');
      }
      if (response.data.message !== undefined) {
        this.setState({
          textError: response.data.message,
          spanError: '',
        });
      }
    }).catch(() => {
    });
  }

  render() {
    const { handleSubmit, t } = this.props;
    const { spanError, textError } = this.state;

    if (this.state.redirect) {
      return <Redirect to="/dashboard" />;
    }
    return (
      <div className="container-fluid home-fluid">
        <div className="home-header">
          <Container>
            <Row>
              <Col md={12} lg={12} sm={12} xs={12}>
                <div className="package-header">
                  <h4><span className="lnr lnr-user" /> <b>{t('LBL.UPDATE_YOUR_PASSWORD')}</b></h4>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <Container className="dashboard" style={{ marginTop: '-70px' }}>
          <Row>
            <Col sm="12" md={{ size: 6, offset: 3 }}>
              <Col md={12}>
                <Card>
                  <CardBody>
                    <h4>{t('LBL.CHANGE_PASSWORD')}</h4>
                    <form className="form" style={{ marginTop: '30px' }} onSubmit={handleSubmit(this.handleSubmit)}>
                      <div className="form__form-group">
                        <span
                          className="form__form-group-error"
                          style={
                            {
                              background: '#ffbcbc',
                              borderRadius: '3px',
                              position: 'absolute',
                              padding: '5px 10px 5px 10px',
                              margin: '-25px 0px 0px 0px',
                              width: '100%',
                              display: spanError,
                              fontSize: '12px',
                              fontStyle: 'italic',
                            }
                          }
                        >
                          {textError}
                        </span>
                      </div>
                      <div className="form__form-group mb-xl-4">
                        <span className="form__form-group-label">{t('LBL.OLD')} {t('LBL.PASSWORD')}</span>
                        <div className="form__form-group-field">
                          <Field
                            name="old_password"
                            component={renderTextInput}
                            value={this.state.oldPassword}
                            onChange={this.handleOldPassword}
                            type={this.state.showOldPassword ? 'text' : 'password'}
                            placeholder={`${t('LBL.OLD')} ${t('LBL.PASSWORD')}`}
                          />
                          <button
                            className={`form__form-group-button${this.state.showOldPassword ? ' active' : ''}`}
                            onClick={e => this.showOldPassword(e)}
                            type="button"
                          ><EyeIcon />
                          </button>
                        </div>
                      </div>
                      <div className="form__form-group mb-xl-4">
                        <span className="form__form-group-label">{t('LBL.NEW_PASSWORD')}</span>
                        <div className="form__form-group-field">
                          <Field
                            name="new_password"
                            component={renderTextInput}
                            value={this.state.newPassword}
                            onChange={this.handleNewPassword}
                            type={this.state.showNewPassword ? 'text' : 'password'}
                            placeholder={`${t('LBL.NEW_PASSWORD')}`}
                          />
                          <button
                            className={`form__form-group-button${this.state.showNewPassword ? ' active' : ''}`}
                            onClick={e => this.showNewPassword(e)}
                            type="button"
                          ><EyeIcon />
                          </button>
                        </div>
                      </div>
                      <div className="form__form-group mb-xl-4">
                        <span className="form__form-group-label">{t('LBL.CONFIRM_NEW_PASSWORD')}</span>
                        <div className="form__form-group-field">
                          <Field
                            name="confirm_password"
                            component={renderTextInput}
                            value={this.state.confirmNewPassword}
                            onChange={this.handleConfirmNewPassword}
                            type={this.state.showConfirmNewPassword ? 'text' : 'password'}
                            placeholder={`${t('LBL.CONFIRM_NEW_PASSWORD')}`}
                          />
                          <button
                            className={`form__form-group-button${this.state.showConfirmNewPassword ? ' active' : ''}`}
                            onClick={e => this.showConfirmNewPassword(e)}
                            type="button"
                          ><EyeIcon />
                          </button>
                        </div>
                      </div>
                      <div className="account__btns">
                        <button
                          className="btn btn-primary account__btn"
                          color="primary"
                          type="submit"
                        >
                          {t('FRM.SAVE')}
                        </button>
                      </div>
                    </form>
                  </CardBody>
                </Card>
              </Col>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
const validate = (values) => {
  const errors = {};
  if (!values.old_password) {
    errors.old_password = 'Old Password field shouldn’t be empty';
  }
  if (!values.new_password) {
    errors.new_password = 'New Password field shouldn’t be empty';
  }
  if (!values.confirm_password) {
    errors.confirm_password = 'Confirm New Password field shouldn’t be empty';
  }
  if (values.new_password !== values.confirm_password) {
    errors.confirm_password = 'Your new password and confirmation password do not match';
  }
  return errors;
};
export default reduxForm({
  form: 'change_password', // a unique identifier for this form
  validate,
})(translate('global')(ChangePassordForm));
